import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

const textFormatter: NodeSerializerSpec = (state, node) => {
	// The reader leaves the text of a link as written, arrows and dashes included.
	const inLink = node.marks.some((mark) => mark.type.name === "link");
	state.text((node.marks ? node.text : node.text.trim()).replaceAll(" ", " "), true, !inLink);
};

export default textFormatter;
